
// import MyRouter from "routers/index";
import { useEffect } from "react";
import { ProductCartContextProvider } from "./contaxt/CartProductContext"
import { Helmet, HelmetProvider } from "react-helmet-async";
import MyRoutes from "routers/index";

function App() {
const isDark=localStorage.getItem('theme')
  useEffect(()=>{
 if(isDark ==="dark"){
  document.documentElement.classList.add("dark");
 }
 else{
  document.documentElement.classList.remove("dark");
 }
  },[isDark])
  return (
    <HelmetProvider>
      <Helmet>
        <title>Basil POS Online Ordering</title>
        <meta
          name="description"
          content="Basil POS Online Ordering"
        />
      </Helmet>
      <ProductCartContextProvider>
      {/* MAIN APP */}
        <div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
          <MyRoutes />
        </div>
      </ProductCartContextProvider>

    </HelmetProvider>
  );
}

export default App;
